import React from 'react';
import { Mail } from 'lucide-react';

const ApplicationForm = () => {
  return (
    <div id="jetzt-bewerben" className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center items-center mb-4">
            <div className="bg-blue-600 text-white p-3 rounded-full">
              <Mail className="h-8 w-8" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Bewerbung für Rechtsanwälte
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
            Werden Sie Teil unseres Expertenteams und helfen Sie Mandanten bei ihren rechtlichen Anliegen.
          </p>
        </div>

        {/* Email Contact Section */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="text-center">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Interesse an einer Zusammenarbeit?
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              Wenn Sie Interesse haben, Teil unseres Teams zu werden, senden Sie bitte Ihre Bewerbungsunterlagen an:
            </p>
            <a 
              href="mailto:karriere@advocall.de"
              className="inline-flex items-center justify-center px-8 py-4 text-xl font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              <Mail className="h-6 w-6 mr-3" />
              karriere@advocall.de
            </a>
            <p className="text-sm text-gray-500 mt-6">
              Wir freuen uns auf Ihre Bewerbung und werden uns zeitnah bei Ihnen melden.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationForm;